import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { CaasRoutes } from '../../../hdi-components/src/shared/interfaces/caas/caas.interface';
import { NavigationService } from './navigation.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorNavigationService {
  private navigationService!: NavigationService;

  constructor(
    private router: Router,
    private injector: Injector
  ) {}

  navigateToErrorPage(errorCode: string): void {
    if (!this.navigationService) {
      this.navigationService = this.injector.get(NavigationService);
    }

    if (errorCode >= '500') {
      this.navigationService.get500().subscribe((routes: CaasRoutes[]) => {
        if (routes.length > 0) {
          const route = routes[0];
          this.router.navigate([route.seoRoute], { state: { errorCode: 500 } });
        } else {
          this.router.navigate(['/500'], { state: { errorCode: 500 } });
        }
      });
    }
  }
}
